import api from './api'

export const chatsAPI = {
  list: () => api.get('/chats.json'),
  get: (id) => api.get(`/chats/${id}.json`),
  create: (data) => api.post('/chats.json', { chat: data }),
  delete: (id) => api.delete(`/chats/${id}.json`),
  invitableUsers: (id) => api.get(`/chats/${id}/invitable_users.json`),
  markRead: (id) => api.post(`/chats/${id}/read.json`),
  unreadTotal: () => api.get('/chats/unread_total.json'),
  invite: (id, userIds) => api.post(`/chats/${id}/members.json`, { user_ids: userIds }),
  sendMessage: (id, body) => api.post(`/chats/${id}/messages.json`, { chat_message: { body } }),
  messages: (id) => api.get(`/chats/${id}/messages.json`),
  stages: (id) => api.get(`/chats/${id}/stages.json`),
  stage: (id, stageId) => api.get(`/chats/${id}/stages/${stageId}.json`),
}
